import React from 'react';
import ParkingZone from './parking-zone';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const parkingZones = _ref => {
  let {
    carParks,
    centre,
    noBorder
  } = _ref;
  return (Array.isArray(carParks) ? carParks : []).slice().map(carPark => /*#__PURE__*/_jsx(ParkingZone, {
    className: noBorder ? '' : style.parkingZoneBorder,
    carParkName: carPark.title,
    carParkLocation: carPark.location,
    carParkEntrance: carPark.entrance,
    bestParkingFor: carPark.bestParkingForCollection ? carPark.bestParkingForCollection.items : carPark.bestParkingFor,
    latitude: carPark.latitude,
    longitude: carPark.longitude,
    centreSlug: centre.slug,
    "data-id": "parking_index_parkingZones_ParkingZone"
  }, carPark.sys.id));
};